<template>
  <v-container class="task-dashboard">
    <v-row>
      <v-col>
        <hr class="spliter">
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="issue-header-row">
          <v-btn
            class="black--text header-btn"
            color="white"
            @click="$refs.taskForm.openDialog()"
            elevation="0">{{$t('buttons:add-specific', {specific: 'Task'})}}</v-btn>
        </div>
        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            icon="file_copy"
            icon2="visibility"
            :iconTooltip="$t('buttons:clone')"
            @updateTableData="updateTable"
            :addBtn="false"
            @clickedButton1="cloneIssue"
            @clickedButton2="v => $refs.viewTaskDialog.openDialog(v)"
            sortBy="incidentDate"
            :sortDesc="true"
            :items-per-page="5"
            disable-items-per-page
            :head-button="true"
            :head-button-icon="showClosed ? 'visibility_off' : 'visibility'"
            :head-btn-text="showClosed ? $t('book/issue:common.hide-closed') : $t('book/issue:common.show-closed')"
            @clickedHeadButton="showHideClosedTasks"
        />
      </v-col>
      <v-col cols="6">
        <DragAndDropComponent
            ref="dragComponent"
        />
      </v-col>
    </v-row>
    <AddTaskDialog
        ref="taskForm"
        @callUpdateDropMenu="$refs.dragComponent.updateData()"
        @closeDialog="closeDialog"
    />
    <ViewTaskDialog
      ref="viewTaskDialog"
      @closeDialog="$refs.table.callTableUpdate()"
      />
  </v-container>
</template>
<script>

import DragAndDropComponent from '@/modules/book/views/task/dashboard-table/DragAndDropComponent';
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import TaskBoardService from '@/modules/book/services/task-board-service';
import ViewTaskDialog from '@/modules/book/views/task/ViewTaskDialog';
import AddTaskDialog from '@/modules/book/views/task/AddTaskDialog';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import Task from '@/modules/book/data/task';

export default {
  name: 'DashboardTable',
  components: {ViewTaskDialog, DataTablePaginated, AddTaskDialog, DragAndDropComponent},
  data() {
    return {
      dragover: false,
      openTaskCode: null,
      showClosed: true
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t('common:name'), value: 'name', sortable:true },
        { text: this.$t('book/issue:add-issue-form.task-date'), value: 'incidentDate', sortable:true },
        { text: this.$t('book/issue:common.appointment-date'), value: 'appointmentDate', sortable:true },
        { text: this.$t('book/issue:status.TASK_STATUS'), value: 'taskStatusString', sortable:true },
        { text: this.$t('common:elevator'), value: 'facilityName', sortable:true },
        { text: '', value: 'controls'}
      ];
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      TaskBoardService.readAllPaginatedFromAPI(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          this.showClosed,
          (response) => {
            if (this.$refs.table !== undefined) {
              response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Task)
              response.data.content.forEach((x) => {

                if (x.taskStatus.length != 0) {

                  var ts = x.taskStatus.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)).slice(-1)[0];
                  x.taskStatusString = this.getTaskStatusTranslation(ts.action);

                } else {
                  x.taskStatusString = this.getTaskStatusTranslation('');
                }
              })
              this.$refs.table.fillTableData(response.data);
            }
          },
          (error) => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}));
            this.$logger.error(error);
          }
      )
    },
    getTaskStatusTranslation(status) {
      if (status === 'OFFER_SIGN') {
        return this.$t('book/issue:bread-crumbs.offer-accepted');
      }
      else if(status === 'FINISH_ORDER') {
        return this.$t('book/issue:bread-crumbs.order-finished')
      }
      else if (status === '') {
        return this.$t('book/issue:bread-crumbs.new');
      }
    },
    closeDialog() {
      this.$refs.table.callTableUpdate();
      this.openTaskCode = null;
    },
    openTaskByCode(task) {
      if (!task) return;
      TaskBoardService.readByTaskCode(
          task,
          (response) => {
            if (response.data) {
              this.$refs.viewTaskDialog.openDialog(response.data);
            }
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task')}));
            this.$logger.error(error);
          }
      )
    },
    cloneIssue(issue) {
      let newTask = Object.assign({}, issue);
      newTask.id = null;
      newTask.taskStatus = [];
      newTask.taskCode = null;
      newTask.boardStatus = "TASK_NEW";
      this.$refs.taskForm.openDialog(newTask);
    },
    showHideClosedTasks() {
      this.showClosed = !this.showClosed;
      this.$refs.table.options.page = 1;
      this.$refs.table.callTableUpdate();
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.task) {
      this.openTaskByCode(this.$route.query.task)
    }
  }
}
</script>

<style lang="scss">
.task-dashboard {
  .table-header {
    background-color: #d6ddff;
    text-align: left;
  }

  .spliter {
    border: 1px solid black;
    margin-bottom: 20px;
  }

  .issue-header-row {
    margin-bottom: 5px;

    .v-btn {
      width: 100%;
    }

    .header-btn {
      vertical-align: top;
    }
  }

  .drop-field {

    .drag-and-drop {
      height: 100%;

      .v-card__text {
        height: 100%;
      }
    }

    .drag-column {
      text-align: center;
    }
    .drag-container {
      height: 100%;
    }
  }

  .row .col.col-6 .ma-1 {
    margin: 0 !important;
  }
}

</style>